/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид используется для инициализации видов, работающих с модальными окнами.
   */
  app.CommonPopupsView = app.View.extend({
    /**
     * @inheritDoc
     */
    run: function () {
      this.initManagersContactsPopup();
      this.initLeftPositionedPopups();
      this.initBreadcrumbsPopup();
      this.initCenterPositonedPopups();
    },

    /**
     * Попап на странице контактов (/kontakty/managers/).
     */
    initManagersContactsPopup: function () {
      $('.contacts-js-popup-opener').each(function () {
        new app.ManagerContactsPopupView({el: $(this)});
      });
    },

    /**
     * Обычный попап с выравниванием по левому краю инициатора.
     */
    initLeftPositionedPopups: function () {
      $('.js-popup-left-opener').each(function () {
        new app.PopupView({
          el: $(this),
          css: function (opener) {
            var leftOffset = opener.offset().left;
            var topOffset = opener.offset().top + opener.innerHeight() + 10;
            if (!app.isDesktop) {
              leftOffset = leftOffset - $('body').position().left;
              topOffset = topOffset - $('body').position().top;
            }
            return {
              left: leftOffset,
              top: topOffset
            };
          }
        });
      });
    },

    /**
     * Обычный попап с выравниванием по центру инициатора, со стрелками "вверх/вниз"
     */
    initCenterPositonedPopups: function () {
      $('.js-popup-positioned-opener').each(function (i, el) {
        var $popup = $('.js-popup-positioned').eq(i),
          $opener = $(el);

        var popup_pos = new als.Popup($popup, $opener);

        popup_pos.addEventListener(
          als.Popup.EventType.BEFORE_OPEN,
          function () {
            var leftOffset = $opener.offset().left - $opener.parent().outerWidth() / 2 + $opener.outerWidth() / 2,
              topOffset = $opener.offset().top + $opener.innerHeight() + 10;
            if (!app.isDesktop) {
              var bodyPosition =  $('body').position();
              leftOffset = leftOffset - bodyPosition.left;
              topOffset = topOffset - bodyPosition.top;
            }
            $popup.css({
              left: leftOffset,
              top: topOffset
            });
            $opener
              .find('.with-icon')
              .toggleClass('with-icon_arrowdown-blue with-icon_arrowup-blue');
          });

        popup_pos.addEventListener(
          als.Popup.EventType.AFTER_CLOSE,
          function () {
            $opener
              .find('.with-icon')
              .toggleClass('with-icon_arrowdown-blue with-icon_arrowup-blue');
          });

      });

      var $popup = $('.popup, .js-popup');
      $popup.appendTo('.popups');
    },

    /**
     * Иниализация попапа хлебных крошек
     */
    initBreadcrumbsPopup: function () {
      var $popup_breadcrumbs = $('.js-breadcrumbs-popup'),
        $opener_breadcrumbs = $('.js-breadcrumbs-opener');

      if ($popup_breadcrumbs.length > 0) {
        $($popup_breadcrumbs).each(function (i, item) {
          new als.Popup($(item), $($opener_breadcrumbs[i]), undefined, 150);
        });
      }
    },
  });
})(jQuery);

}.call(window));